import { SafelySetInnerHTML } from "@faire/web--source/common/SafelySetInnerHTML";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { fontRamp } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";

export const FormattedText: React.FC<{
  text?: string;
}> = React.memo(({ text }) => {
  const isSSR = useIsSSR();
  return !isSSR && text?.length ? (
    <StyleOverride>
      <SafelySetInnerHTML html={text} tag="span" />
    </StyleOverride>
  ) : null;
});

// This component overrides the font weight of <b> tag to medium, since
// our texts use medium font weight for bold, but BE only send us <b> tag
const StyleOverride = styled.span`
  b {
    font-weight: ${fontRamp.fonts.paragraphSansMedium["font-weight"]};
  }
`;
